define([
    "angular",
    "./externalFreightModule"
], function (angular, freightModule) {
    "use strict";
    freightModule.provider("externalFreightServiceUrl", [function () {

        var calculateFreightUrlForNodeIdentifier;
        var selectExternalFreight;

        this.$get = [function () {
            return {
                getCalculateFreightUrlForNodeIdentifier: getCalculateFreightUrlForNodeIdentifier,
                getSelectExternalFreight: getSelectExternalFreight
            };
        }];

        function getCalculateFreightUrlForNodeIdentifier() {
            return calculateFreightUrlForNodeIdentifier;
        }

        function getSelectExternalFreight() {
            return selectExternalFreight;
        }

        this.configure = function (server) {
            calculateFreightUrlForNodeIdentifier = server.calculateFreightUrlForNodeIdentifier;
            selectExternalFreight = server.selectExternalFreight;
        };
    }]);
});

